import {
  ContentHubSeriesNavigationBarFields,
  TNavigationBarFields,
  TNavigationBarProps,
  TSeriesTitle,
  TNavigationBarParams,
} from '../types/navigationBar.types';
import { TContentHubButton, TLinkField, TStringField } from '../../../../types/types';

export class NavigationBarModel {
  private readonly fields: TNavigationBarFields | ContentHubSeriesNavigationBarFields;
  private readonly params: TNavigationBarParams;
  private readonly isEditorial: boolean;

  constructor(props: TNavigationBarProps) {
    this.fields = props?.fields || null;
    this.params = props?.params || {};
    this.isEditorial = !!props.isEditorial;
  }

  get editorialTitle(): TStringField | undefined {
    return (this.fields as TNavigationBarFields)?.title;
  }

  get editorialCTA(): TLinkField | undefined {
    return (this.fields as TNavigationBarFields)?.primarycta;
  }

  get tabs(): string[] {
    if (this.isEditorial && !this.fields) return [];

    if (this.isEditorial && 'items' in this.fields) {
      return this.fields?.items
        ?.map((param) => {
          return param?.fields?.ctalabel;
        })
        .filter((tab) => !!tab) as string[];
    }

    if (!this.isEditorial) {
      const regex = new RegExp('navigationSection[0-9]');
      return Object.keys(this.params)
        ?.sort((a, b) => a?.localeCompare?.(b))
        .map((param: string) => {
          if (regex.test(param)) return this.params[param];
        })
        .filter((tab) => !!tab) as string[];
    }

    return [];
  }

  get showDropdown(): boolean {
    return true;
  }

  get showLabel(): boolean {
    return true;
  }

  get seriesList(): TSeriesTitle[] | undefined {
    // eslint-disable-line
    if (this.fields && 'apiData' in this.fields) return this.fields?.apiData?.seriesList;
    return undefined;
  }

  get isUnderSuperSerie(): boolean | undefined {
    if (this.fields && 'apiData' in this.fields) return this.fields?.apiData?.isUnderSuperSerie;
    return undefined;
  }

  get contextItemUrl(): string {
    if (this.fields && 'itemData' in this.fields) return this.fields?.itemData?.contextItemUrl || '';
    return '';
  }

  get title(): string | undefined {
    if (this.fields && 'apiData' in this.fields) return this.fields?.apiData?.seriesDetails?.title;
    return undefined;
  }

  get optionalLabel2(): string | undefined {
    if (this.fields && 'apiData' in this.fields) return this.fields?.apiData?.seriesDetails?.optionalLabel2;
    return undefined;
  }

  get optionalLabel1(): string | undefined {
    if (this.fields && 'apiData' in this.fields) return this.fields?.apiData?.seriesDetails?.optionalLabel1;
    return undefined;
  }

  get msrp(): string | undefined {
    if (this.fields && 'apiData' in this.fields) return this.fields?.apiData?.seriesDetails?.msrp;
    return undefined;
  }

  get button1(): TContentHubButton | undefined {
    if (this.fields && 'apiData' in this.fields) return this.fields?.apiData?.seriesDetails?.button1;
    return undefined;
  }

  get enableBuildPriceCTA(): boolean | undefined {
    return this.params?.enableBuildPriceCTA === '1';
  }
}
